/**
 * Tailwind fill class for an HP bar, based on the current/max ratio.
 * Shared between the waifu list cards and the waifu profile so they match.
 */
export function hpFillClass(current: number, max: number): string {
  if (current <= 0) return 'bg-danger';
  const pct = max > 0 ? (current / max) * 100 : 0;
  return pct > 50 ? 'bg-success' : pct > 25 ? 'bg-gold' : 'bg-danger';
}
